<template>
  <!--询盘服务-->
  <div class="ab-customs">
    <div class="ab-customs-header flex-row">
      <div class="ab-banner-header">
        <MainNav />
        <div class="ab-customs-info">
          <div class="warp">
            <div class="fontsize50" data-aos="fade-down">
              AB客海关数据&nbsp;&nbsp;赋能全球贸易
            </div>
            <div class="banner-tabs">
              <a-tabs
                type="card"
                data-aos="fade-down"
                data-aos-delay="100"
                v-model="activeKey"
                @change="tabChange"
              >
                <a-tab-pane key="commodity" tab="全部">
                  <a-input-group class="inputflex">
                    <a-input-search
                      ref="commodity"
                      class="inputSearch"
                      @search="onSearch"
                      placeholder="请输入需要查询的公司名称、产品名或HS编码"
                    >
                      <a-button type="primary" slot="enterButton">
                        <i class="iconfont icon-sousuo"> </i>
                        查询
                      </a-button>
                    </a-input-search>
                  </a-input-group>
                  <ul class="ab-customs-a clearfix">
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('furniture')"
                      >
                        furniture
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="onSearch('battery')">
                        battery
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('electric car')"
                      >
                        electric car
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('sporting goods')"
                      >
                        toys
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('medical instruments')"
                      >
                        medical instruments
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('Electronic Component')"
                      >
                        Electronic Component
                        <em> </em>
                      </a>
                    </li>
                  </ul>
                </a-tab-pane>
                <a-tab-pane key="exportCustomerName" tab="供应商" force-render>
                  <a-input-group class="inputflex">
                    <!-- <a-input placeholder="请输入需要查询的供应商公司名称" />
                  <a-button type="primary">
                    <i class="iconfont icon-sousuo"> </i>
                    查询
                  </a-button> -->

                    <a-input-search
                      ref="exportCustomerName"
                      class="inputSearch"
                      @search="onSearch"
                      placeholder="请输入需要查询的供应商公司名称"
                    >
                      <a-button type="primary" slot="enterButton">
                        <i class="iconfont icon-sousuo"> </i>
                        查询
                      </a-button>
                    </a-input-search>
                  </a-input-group>
                  <!-- <ul class="ab-customs-a clearfix">
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('steel coils')"
                      >
                        steel coils
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('elevator')"
                      >
                        elevator
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('gaming headset')"
                      >
                        gaming headset
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('vending machine')"
                      >
                        vending machine
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('brake pads')"
                      >
                        brake pads
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="onSearch('beeswax')">
                        beeswax
                        <em> </em>
                      </a>
                    </li>
                  </ul> -->
                  <ul class="ab-customs-a clearfix">
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('furniture')"
                      >
                        furniture
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="onSearch('battery')">
                        battery
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('electric car')"
                      >
                        electric car
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('sporting goods')"
                      >
                        toys
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('medical instruments')"
                      >
                        medical instruments
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('Electronic Component')"
                      >
                        Electronic Component
                        <em> </em>
                      </a>
                    </li>
                  </ul>
                </a-tab-pane>
                <a-tab-pane key="importCustomerName" tab="采购商">
                  <a-input-group class="inputflex">
                    <!-- <a-input placeholder="请输入需要查询的采购商公司名称" />
                  <a-button type="primary">
                    <i class="iconfont icon-sousuo"> </i>
                    查询
                  </a-button> -->

                    <a-input-search
                      ref="importCustomerName"
                      class="inputSearch"
                      @search="onSearch"
                      placeholder="请输入需要查询的采购商公司名称"
                    >
                      <a-button type="primary" slot="enterButton">
                        <i class="iconfont icon-sousuo"> </i>
                        查询
                      </a-button>
                    </a-input-search>
                  </a-input-group>
                  <ul class="ab-customs-a clearfix">
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('furniture')"
                      >
                        furniture
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" @click="onSearch('battery')">
                        battery
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('electric car')"
                      >
                        electric car
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('sporting goods')"
                      >
                        toys
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('medical instruments')"
                      >
                        medical instruments
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('Electronic Component')"
                      >
                        Electronic Component
                        <em> </em>
                      </a>
                    </li>
                  </ul>
                  <!-- <ul class="ab-customs-a clearfix">
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('Fiber optic cable')"
                      >
                        Fiber optic cable
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('led monitor')"
                      >
                        led monitor
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('packing machine')"
                      >
                        packing machine
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('pet supplies')"
                      >
                        pet supplies
                        <em> </em>
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:void(0)"
                        @click="onSearch('Aluminum foil container')"
                      >
                        Aluminum foil container
                        <em> </em>
                      </a>
                    </li>
                  </ul> -->
                </a-tab-pane>
              </a-tabs>
            </div>
            <dl data-aos="fade" data-aos-delay="200">
              <dd>
                <span class="fontsize50">
                  <NumberGrow :value="12"></NumberGrow>
                </span>
                <span class="fontsize40"> 亿 </span>
                <span class="fontsize26"> &nbsp;条海关贸易数据 </span>
              </dd>
              <dd>
                <span class="fontsize50">
                  <NumberGrow :value="5"></NumberGrow>
                </span>
                <span class="fontsize40"> 亿 </span>
                <span class="fontsize26"> &nbsp;搜索数据 </span>
              </dd>
              <dd>
                <span class="fontsize50">
                  <NumberGrow :value="20"></NumberGrow>
                </span>
                <span class="fontsize40"> 亿 </span>
                <span class="fontsize26"> &nbsp;条社交数据 </span>
              </dd>
              <dd>
                <span class="fontsize50">
                  <NumberGrow :value="80"></NumberGrow>
                </span>
                <span class="fontsize40"> + </span>
                <span class="fontsize26"> &nbsp;国家及地区 </span>
              </dd>
              <dd>
                <span class="fontsize50">
                  <NumberGrow :value="1000"></NumberGrow>
                </span>
                <span class="fontsize40"> + </span>
                <span class="fontsize26"> &nbsp;外贸营销方案 </span>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <!--智能拓客平台-->
    <CustomerPlatform v-bind="platformData"></CustomerPlatform>

    <!--优势对比-->
    <Competitive :dataList="competitiveData"></Competitive>
    <!--服务列表价格清单-->
    <!-- <ServerList></ServerList> -->
    <!--问题列表-->
    <div class="ad-customs-questionData">
      <QuestionList v-bind="questionData"></QuestionList>
    </div>
    <!--已服务列表-->
    <CustomerList></CustomerList>

    <FooterBanner
      ><img src="~@/assets/product/fb_1.png" alt="数据外贸营销，从现在开始！"
    /></FooterBanner>
    <list-modal-vue
      :visible="visible"
      :keywords="keywords"
      :queryField="activeKey"
      @cancel="handleCancel"
    ></list-modal-vue>
  </div>
</template>

<script>
import MainNav from "@/components/MainNav.vue";
import NumberGrow from "@/components/NumberScrolling.vue";
// import AbBlock from '@/components/AbBlock.vue';
// import Features from '@/components/Features.vue';
import Competitive from "@/components/Competitive.vue";
// import ServerList from '@/components/ServerList.vue';
import QuestionList from "@/components/QuestionList.vue";
import CustomerList from "@/components/CustomerList.vue";
import FooterBanner from "@/components/FooterBanner.vue";
import Superiority from "./Customs/Superiority.vue";
import CustomerPlatform from "@/components/CustomerPlatform.vue";
import ListModalVue from "./Customs/ListModal.vue";
import metaInfo from "@/metaInfo";
export default {
  metaInfo: metaInfo["customs"],
  components: {
    MainNav,
    NumberGrow,
    // Features,
    Competitive,
    // ServerList,
    QuestionList,
    CustomerList,
    FooterBanner,
    Superiority,
    CustomerPlatform,
    ListModalVue,
  },
  data() {
    return {
      visible: false,
      activeKey: "commodity",
      keywords: "",
      questionData: {
        blockTitle: "常见问题",
        blockSubTitle: "帮助客户快速解决问题",
        listData: [
          {
            q: "为什么查询次数受限，有些数据搜不到？",
            a:
              "AB客海关数据分为不同的应用版本，初次注册用户可免费体验，体验版和付费版数据量及权限是不同的，免费版每天的查询数量有限，若想体验更多功能和数据请联系在线客服或在线填写联系方式，我们会尽快安排业务经理为您进行远程演示。因其部分国家政策原因，限制了相关海关数据的流通，因此部分国家地区海关数据查询不到实为正常。",
          },
          {
            q: "如何升级海关数据",
            a:
              "升级海关数据需要您登录AB客CRM系统进行操作，您也可以联系在线客服并留下联系方式，我们会尽快安排客户经理和您联系，或点击自主升级链接:https://crm.cnabke.com/#/Account/CrmRecharge",
          },
          {
            q: "AB客海关数据到底有什么作用",
            a:
              "AB客的海关数据不仅有数据源国的具体进出口公司信息及产品信息，同时以进出口公司价值链为中心全方位拓展透视，其聚合了搜索数据及社媒数据，比原数据更加完整、精准，同时提供全景动态分析报表，为企业决策提供更有利的参考依据。",
          },
          {
            q: "AB客海关数据如何计费？",
            a:
              "区别于市面上其他的平台以单条计费、打包计费形式，AB客海关数据的计费模式更加符合现代外贸企业的低成本需求，不同版本的海关数据日搜索、查看信息次数不同，需求量高的企业可以选择高阶版本，需求量低的企业可选择低阶版本，且低阶版本的用户可随时发起版本升舱。",
          },
        ],
      },
      competitiveData: {
        title: "区别于市面其他产品",
        subTitle: "集买卖家查找与市场分析为一体",
        data: [
          {
            title: "市面其他海关数据",
            features: [
              "均为二手数据，精准度低且更新不及时",
              "数据信息不完整，缺少相关联系方式",
              "数据杂乱不堪，需要客户自己整理分析",
              "数据购买成本高，整体转化效率低",
              "单一查看权限，不能高效率应用线索",
            ],
          },
          {
            title: "AB客海关数据",
            features: [
              "AB客五大数据中心支持，更加真实有效",
              "通过AI大数据补全信息，精准定位决策人",
              "多维数据可视化报告，全面观测一目了然",
              "集买卖家查找与市场分析为一体",
              "SCRM一键添加潜在客户，实时追踪商机",
            ],
          },
        ],
      },
      platformData: {
        blockTitle: "智能拓客平台",
        blockSubTitle: "基于海关数据打造贸易营销闭环",
        blockList: [
          {
            title: "企业实力透视",
            content:
              "基于数十亿的数据资源，结合科学的数字模型下钻分析，深度挖掘商业价值链路，实时交叉核验对比，精准映射目标商家周边贸易场景，快速掌握商家实力背景，降低交易合作风险。",
            image: "product/海量外贸数据支持.jpg",
          },
          {
            title: "市场商情监测",
            content:
              "全球定向监控竞品，动态溯源追踪，实时捕捉上下游行为轨迹，精准定位监控范围，及时发出预警，让商家快速掌握事件信息，提前启动应对策略，降低事件成本及风险。",
            image: "product/全球追踪分析.jpg",
          },
          {
            title: "优质客户开发",
            content:
              "海量真实交易数据加持，高度还原交易贸易场景，覆盖全行业细分品类，精准锁定优质国外商家，快速获取核心决策人联系方式，简化外贸客户开发流程，有效缩短中间营销链路。",
            image: "product/大数据精准获客.jpg",
          },
          {
            title: "ABI经营决策",
            content:
              "满足不同角色应用需求，全景可视化经营报表分析拓展，智能构建多元化分析模型，高效提升数据预演、挖掘、分析能力，全面打通SCRM营销渠道数据，助力公司经营决策。",
            image: "product/企业实力透视.jpg",
          },
        ],
      },
    };
  },
  methods: {
    onSearch(value) {
      value = value.trim();
      if (!value) {
        return;
      }
      this.visible = true;
      this.keywords = value;
      this.$refs[`${this.activeKey}`].focus();
    },

    handleCancel() {
      this.visible = false;
    },

    tabChange(key) {
      this.activeKey = key;
    },
  },
};
</script>

<style lang="sass">
.ad-customs-questionData{
  .ab-question .q-list .q-item .q-block{
    padding-bottom:0px;
    height:280px;
  }
}
.inputflex{
  input{
      flex: 1;
  }
  display:flex
}
.ab-customs .index_seven {
    height: 19.33333rem;
}
.mainnav{
	position: relative
}
 .ab-customs-info{
    position: absolute;
    top: 0px;
    width: 100%;

    .banner-tabs{
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .inputSearch{
      width: 1000px;
    }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{
    color:#2B68FF
  }
  dl{
    padding-left:144px;
  }
  dd{letter-spacing: 2px;
  padding-bottom:15px;
    .fontsize50,.fontsize40{
     color: #2B68FF;
     font-weight:600;padding-bottom: 14px;
    }
  }
  .ant-tabs-nav{
    padding-left:15px;
  }
  .ab-customs-a li:last-child a em{
	  display: none;
  }
  .ab-customs-a{
    padding-left:18px;
    li{
      a:hover{
        color:#333;
      }
    a{
      float: left;position: relative;
      font-size:20px;      font-family: 'Alibaba-PuHuiTi-R';
      color:rgba(51,51,51,0.4);
      padding:10px 20px;
      em{
        width: 1px;
height: 18px;
background: #D8D8D8;    display: inline-block;
    position: absolute;
     right: 0px;
    top: 16px;
      }
    }
    }
  }


  .ant-btn-primary{
    width: 160px;
height: 64px;  font-size:20px;
background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
border-radius: 0px 8px 8px 0px;
i{
  font-size:30px;
      vertical-align: middle;
    margin-right: 4px;
}
  }.ant-btn-primary:hover{
     background: #0072e7;transition:none
  }
  .ant-input{
    font-size:20px;
      font-family: 'Alibaba-PuHuiTi-R';
      height:64px;
      border-radius: 8px;

  }
  .ant-tabs-bar{
    border:none;
    margin-bottom:8px;
  }
  .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab{
    background:none;
    border:none;padding: 0px 25px;
    font-size:20px;

  }

  .ant-tabs{
    // width:960px;
    margin:50px auto ;
  }
    padding-top:194px;
    .fontsize50{
      text-align:center;
    }
 }
.ab-customs-header {
  height:997px;
  background: url('~@/assets/images/背景_海关数据.jpg') no-repeat;
  background-size: cover;
}

.ab-banner-header {
  width: 100%;
}
</style>
